import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App.tsx";
import { PostHogProvider } from "posthog-js/react";
import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";

const options = {
  api_host: "https://us.i.posthog.com",
  maskAllInputs: false,
  disabled: import.meta.env.DEV,
  host: "https://us.i.posthog.com",
  enableSessionReplay: true,
  sessionReplayConfig: {
    maskAllTextInputs: false,
    maskAllImages: false,
    captureLog: true,
    captureNetworkTelemetry: true,
    androidDebouncerDelayMs: 500,
    iOSdebouncerDelayMs: 1000,
  },
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: false,
      color: false,
      date: false,
      "datetime-local": false,
      email: false,
      month: false,
      number: false,
      range: false,
      search: false,
      tel: false,
      text: false,
      time: false,
      url: false,
      week: false,
      textarea: false,
      select: false,
    },
  },
};

const config = {
  apiKey: "hbp_E5KGQDUYJ6Q3XetqshwSFKWHDUJB3v3AIvKD",
  environment: import.meta.env.DEV ? "development" : "production",
  revision: "0.1",
};
const honeybadger = Honeybadger.configure(config);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HoneybadgerErrorBoundary
      honeybadger={honeybadger}
      ErrorComponent={() => null}
    >
      <PostHogProvider
        apiKey={"phc_EYdaJIEk3ZAhsqx5S9HhE0VrlpyQb8227ZEaNJ8ymBo"}
        options={options}
      >
        <App />
      </PostHogProvider>
    </HoneybadgerErrorBoundary>
  </StrictMode>,
);
